module.exports = __webpack_public_path__ + "img/save.e7ec8f4f.png";